import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EventListener from 'react-event-listener';
import { debounce } from 'lodash/fp';

const renderOnResolutionChange = (InnerComponent, debounceTime) =>
  class RenderOnResolutionChange extends Component {
    static contextTypes = {
      store: PropTypes.object,
    };
    constructor(props) {
      super(props);
      this.onResize = debounce(debounceTime || 200, this.onResize.bind(this));
    }
    state = {
      width: window.innerWidth,
      forceUpdate: false,
    };
    componentDidMount() {}
    onResize = () => {
      const { width } = this.state;
      if (
        (width > 1023 && window.innerWidth < 1023) ||
        (width < 1023 && window.innerWidth > 1023)
      ) {
        this.forceUpdate();
        this.setState({
          forceUpdate: !this.state.forceUpdate,
          width: window.innerWidth,
        });
      }
    };
    render() {
      return (
        <EventListener target="window" onResize={this.onResize}>
          <InnerComponent
            {...this.props}
            forceUpdate={this.state.forceUpdate}
          />
        </EventListener>
      );
    }
  };

export default renderOnResolutionChange;
